import { render, staticRenderFns } from "./Wx.vue?vue&type=template&id=04be967e&scoped=true&"
import script from "./Wx.vue?vue&type=script&lang=js&"
export * from "./Wx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be967e",
  null
  
)

export default component.exports